export default __webpack_public_path__ + "static/media/close_selection.5f364816.svg";